
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/documents",
      function () {
        return require("private-next-pages/[lang]/documents/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/documents"])
      });
    }
  